<template>
  <section class="personal-schedule-section">
    <div class="personal-calendar-container" v-if="showCalendar">
      <vue-cal
        class="vuecal-container"
        ref="vuecal"
        id="vuecal"
        :locale="`pt-br`"
        today-button
        events-on-month-view="short"
        :time-from="timeFrom"
        :time-to="timeTo"
        :time-step="timeCellHeight"
        :snap-to-time="timeCellHeight"
        :time-cell-height="timeCellHeight"
        :watchRealTime="true"
        :cell-click-hold="true"
        :drag-to-create-event="true"
        :disable-views="['years', 'year']"
        :events="events"
        :selected-date="selectedDate"
        :editable-events="{ title: false, drag: true, resize: true, delete: true, create: true }"
        :on-event-click="eventClick"
        @cell-click="cellClick"
        @ready="scrollToCurrentTime"
        @event-create="eventCreate"
        @event-drop="eventDrop"
        @event-change="eventChange"
        @event-resizing="eventResizing"
        @event-delete="eventDelete"
        @event-title-change="eventChange"></vue-cal>
      <!-- SIDE -->
      <div class="personal-calendar-side-container">
        <!-- TOP BAR -->
        <div class="side-list-top-bar-container">
          <div class="side-list-top-bar-item">
            <i :title="$t('userSchedule.downloadEvents')" class="fas fa-file-download" @click="downloadAllEvents"></i>
            <label>{{ eventsComputed.length }} {{ $t('userSchedule.appointments') }}</label>
          </div>
          <div class="side-list-top-bar-item">
            <!-- <button class="button" @click="eventClick(initialPayload,{button:13})">CRIAR</button> -->
            <i class="fas fa-plus-circle" @click="eventClick(initialPayload, { button: 13 })"></i>
          </div>
        </div>
        <!-- SIDE LIST -->
        <div class="events-list-container">
          <!-- SIMPLE EVENT ITEM -->
          <div class="event-list-item" v-for="event in eventsComputed" :key="event.schedule_id" @click="listClickHandler(event)">
            <div class="color-field" :class="event.class"></div>
            <div class="date-field-day" v-html="`<span style='color:#606060;font-size:1.05rem'><b>${dayjs(event.start).format('D')}</b></span>`"></div>
            <div class="date-field-week-month" v-html="`<span style='color:gray'>${dayjs(event.start).format('MMM, ddd')}</span>`"></div>
            <div class="date-field-time" v-html="`<span style='color:#202020'>${dayjs(event.start).format('HH:mm')} - ${dayjs(event.end).format('HH:mm')}</span>`"></div>
            <div class="title-field">{{ event.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- DIALOG BOX -->
    <div class="user-schedule-dialog-box-container" v-if="showDialog">
      <div class="user-schedule-dialog-box-close-btn" @click.prevent="showDialog = !showDialog"></div>
      <div class="user-schedule-dialog-box">
        <EventCard :event="selectedEvent" @saved="eventChange" @deleted="apiDeleteSchedule(selectedEvent.schedule_id)" :isEditing="isEditing" @clickEdit="isEditing = !isEditing" @closeCard="showDialog = false" />
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import 'vue-cal/dist/drag-and-drop.es.js';
import 'vue-cal/dist/i18n/pt-br.es.js';
import * as dayjs from 'dayjs';
import EventCard from '@/components/general/EventCard.vue';

export default {
  name: 'UserSchedule',
  components: {
    VueCal,
    EventCard,
  },
  props: { user_id: String, gotoDate: Date },

  data() {
    return {
      dayjs: null,
      showCalendar: true,
      showDialog: false,
      minEventWidth: 0,
      events: [],
      apiBusy: false,
      timeFrom: 8 * 60,
      timeTo: 24 * 60,
      timeCellHeight: 30,
      selectedDate: null,
      selectedEvent: {},
      initialPayload: {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: null,
        start_date: new Date(Date.now()),
        finish_date: new Date(Date.now()),
        title: 'NEW EVENT',
        description: 'description',
        notes: 'notas...',
        class: 'default',
        config: JSON.stringify({ class: 'typeA' }),
        links: [{ type: 'url', url: 'https://www.blitzar.com.br/' }],
        guests: JSON.stringify([{ user_id: 'ee743390-7a95-11ea-9ca4-6f54e6b90ced', name: '' }]),
        organizer: this.$store.state.user.id,
        status: 'Aguardando aceite',
        confirm: JSON.stringify(false),
        public: JSON.stringify(true),
      },
      isEditing: false,
      dateFilter: new Date(Date.now()),
    };
  },
  computed: {
    eventsComputed() {
      return this.events
        .filter((event) => event.start?.getFullYear() === this.dateFilter?.getFullYear() && event.start.getMonth() >= this.dateFilter.getMonth() && event.start.getDate() >= this.dateFilter.getDate())
        .sort((a, b) => new Date(a.start) - new Date(b.start));
    },
  },
  beforeMount() {
    this.dayjs = dayjs;
    this.dateFilter = new Date(Date.now());
    this.apiGetSchedule();
  },
  mounted() {
    if (this.gotoDate) this.selectedDate = this.gotoDate;
  },
  methods: {
    apiGetSchedule() {
      // console.log('getSchedule');
      let userQuery = this.user_id ? `?user_id=${this.user_id}` : '';
      api
        .get(`event/${this.$store.state.eventId}/schedule${userQuery}`)
        .then((response) => {
          // console.log('apiGetSchedule:', response.data);
          // this.schedule = response.data;
          this.events = [];
          response.data.map((item) => {
            this.events.push({
              ...item,
              start: new Date(item.start_date),
              end: new Date(item.finish_date),
              content: item.description,
              links: JSON.parse(item.links),
              config: item.config ? JSON.parse(item.config) : '',
              draggable: item.config ? JSON.parse(item.config).draggable : true,
              resizable: item.config ? JSON.parse(item.config).resizable : true,
              class: item.config ? JSON.parse(item.config).class : '',
              public: JSON.parse(item.public),
              guests: JSON.parse(item.guests),
              confirm: JSON.parse(item.confirm),
            });
          });
          this.showDialog = false;
        })
        .catch((err) => console.log(err));
    },
    eventClick(event, e) {
      // console.log('eventClick', { event }, { e });
      if (e.button === 0) {
        this.isEditing = false;
        this.selectedEvent = event;
        this.showDialog = true;
        // Prevent navigating to narrower view (default vue-cal behavior).
        // e.stopPropagation();
      }
      if (e.button === 13) {
        this.isEditing = true;
        this.selectedEvent = this.initialPayload;
        this.showDialog = true;
        // Prevent navigating to narrower view (default vue-cal behavior).
        // e.stopPropagation();
      }
    },
    cellClick(e) {
      console.log('cellClick', { e });
      this.dateFilter = e;
      this.selectedDate = e;
    },
    listClickHandler(event) {
      this.scrollToEventTime(event);
      this.selectedDate = event.start;
      this.selectedEvent = event;
      this.showDialog = true;
    },
    eventCreate(data) {
      console.log('eventCreate', { data });
      let payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: null,
        start_date: data.start,
        finish_date: data.end.setHours(data.end.getHours() + 1),
        title: 'NEW EVENT',
        description: 'description',
        notes: 'notas...',
        config: JSON.stringify({ class: 'default', draggable: true, resizable: true }),
        links: JSON.stringify([{ type: 'url', url: 'https://www.blitzar.com.br/' }]),
        guests: JSON.stringify([{ user_id: 'ee743390-7a95-11ea-9ca4-6f54e6b90ced', name: '' }]),
        organizer: this.$store.state.user.id,
        status: 'Confirmado',
        confirm: JSON.stringify(false),
        public: JSON.stringify(true),
      };
      this.apiPostSchedule(payload);
    },
    eventDelete(e) {
      console.log('eventDelete', e);
      this.apiDeleteSchedule(e.schedule_id);
    },
    eventDrop(e) {
      console.log('eventDrop', e);
    },
    eventChange(data) {
      if (!this.apiBusy) {
        console.log('eventChange', { data });
        let payload = {
          schedule_id: data.event.schedule_id,
          event_id: this.$store.state.eventId,
          user_id: this.user_id ? this.user_id : this.$store.state.user.id,
          activity_id: null,
          start_date: data.event.start,
          finish_date: data.event.end,
          title: data.event.title,
          description: data.event.description,
          notes: data.event.notes,
          links: JSON.stringify(data.event.links),
          guests: JSON.stringify(data.event.guests),
          organizer: this.$store.state.user.id,
          status: data.event.status,
          confirm: JSON.stringify(data.event.confirm),
          public: JSON.stringify(data.event.public),
          config: JSON.stringify({ class: data.event.class, draggable: data.event.draggable ? data.event.draggable : true, resizable: data.event.resizable ? data.event.resizable : true }),
        };
        this.apiPutSchedule(payload);
      }
    },
    eventResizing(e) {
      // console.log('eventResizing', e);
    },
    scrollToCurrentTime(e) {
      // console.log('SCROLL', { e });
      const calendar = document.querySelector('#vuecal .vuecal__bg');
      let now = new Date(Date.now());
      let timezoneOffset = now.getTimezoneOffset();
      let hours = now.getHours() + now.getMinutes() / 60;
      calendar.scrollTo({ top: hours * this.timeCellHeight * (60 / this.timeCellHeight) - this.timeFrom, behavior: 'smooth' });
      // console.log(now.getHours(), now, hours, timezoneOffset / 60);
    },
    scrollToEventTime(event) {
      const calendar = document.querySelector('#vuecal .vuecal__bg');
      let now = event.start;
      let timezoneOffset = now.getTimezoneOffset();
      // console.log(timezoneOffset);
      // let hours = now.getHours() + now.getMinutes() / 60 - timezoneOffset / 60;
      let hours = now.getHours() + now.getMinutes() / 60;
      calendar.scrollTo({ top: hours * this.timeCellHeight * (60 / this.timeCellHeight) - this.timeFrom, behavior: 'smooth' });
    },
    apiPostSchedule(payload) {
      (this.apiBusy = true), console.log('postSchedule');
      api
        .post(`event/${this.$store.state.eventId}/schedule/`, payload)
        .then((response) => {
          this.apiBusy = false;
          console.log('apiPostSchedule:', { response });
          this.apiGetSchedule();
        })
        .catch((err) => {
          this.apiBusy = false;
          console.log(err);
        });
    },
    apiDeleteSchedule(id) {
      console.log('apiDeleteSchedule');
      api
        .delete(`event/${this.$store.state.eventId}/schedule/${id}`)
        .then((response) => {
          console.log('apiDeleteSchedule:', { response });
          this.events = this.events.filter((item) => item.schedule_id != id);
          this.showDialog = false;
        })
        .catch((err) => console.log(err));
    },
    apiPutSchedule(payload) {
      if (payload.schedule_id) {
        api
          .put(`event/${this.$store.state.eventId}/schedule/${payload.schedule_id}`, payload)
          .then((response) => {
            console.log('apiPutSchedule:', { response });
            this.apiGetSchedule();
          })
          .catch((err) => console.log(err));
      } else {
        this.apiPostSchedule(payload);
      }
    },
    listDateFormatHandler(event) {
      // console.log(start);
      return `<span style="color:#606060;font-size:1.05rem"><b>${this.dayjs(event.start).format('D')}</b></span> <span style="color:gray">${this.dayjs(event.start).format('MMM, ddd')}</span> ${this.dayjs(event.start).format(
        'HH:mm'
      )} - ${this.dayjs(event.end).format('HH:mm')}`;
    },
    downloadAllEvents() {
      this.eventsComputed.map((event) => {
        this.$ics.addEvent('pt-br', event.title, event.content, 'location', event.start, event.end, 'url', 'organizer');
      });
      this.$ics.download('events');
      this.$ics.removeAllEvents();
    },
  },
};
</script>

<style lang="scss">
.personal-schedule-section {
  position: relative;
  height: 700px;
  width: 90%;
  max-width: 1400px;
  @include media('<=tablet') {
    width: 100%;
  }
}
.personal-calendar-container {
  height: 700px;
  margin-top: 40px;
  display: flex;
  @include media('<=tablet') {
    height: 1000px;
    flex-direction: column;
  }
}
.personal-calendar-side-container {
  min-width: 29%;
}
.vuecal-container {
  height: 100%;
  @include media('<=tablet') {
    height: 50%;
  }
}
.side-list-top-bar-container {
  background: #eee;
  // padding: 0 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.side-list-top-bar-item {
  margin: 0 10px;
  color: black;
}
.events-list-container {
  color: black;
  background: var(--userProfile-middleBgColor);

  padding: 10px;
  display: flex;
  flex-direction: column;
  // gap: 10px;
  height: 660px;
  width: 100%;
  overflow-y: auto;
  @include media('<=tablet') {
    width: 100%;
    // margin: 20px 0 0 0;
    height: 354px;
  }
  &::-webkit-scrollbar {
    // display: none;
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;

    // border-radius: 12px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc !important;
    border-radius: 4px;
    background-image: none !important;
  }
}
.event-list-item {
  cursor: pointer;
  background: #ffffff;
  margin: 4px 0;
  width: 100%;
  display: flex;
  align-items: center;
  .date-field-day {
    width: 7%;
    font-size: 0.9rem;
    padding: 6px 0px;
    // text-transform: uppercase;
  }
  .date-field-week-month {
    width: 20%;
    font-size: 0.9rem;
    padding: 6px 0px 3px;
    // text-transform: uppercase;
  }
  .date-field-time {
    width: 28%;
    font-size: 0.9rem;
    padding: 6px 0px 3px;
    // text-transform: uppercase;
  }
  .color-field {
    width: 9px;
    height: 100%;
    margin-right: 6px;
  }
  .title-field {
    width: 34%;
    // flex-grow: 1;
    padding: 6px 0px;
  }

  @include media('<=tablet') {
    // width: 28%;
    // height: 200px;
    // overflow-y: auto;
  }
}
.user-schedule-dialog-box-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #40404090;
}
.user-schedule-dialog-box-close-btn {
  position: absolute;
  top: 0;
  left: 0;
  // background: #40404030;
  height: 100%;
  width: 100%;
  cursor: pointer;
  z-index: 2;
}
.user-schedule-dialog-box {
  position: relative;
  color: black;
  background: white;
  width: 40%;
  // padding: 14px 20px;
  // cursor: pointer;
  z-index: 2;
  border-radius: 10px;
  box-shadow: 0 12px 32px 12px rgba(0, 0, 0, 0.2);
  @include media('<=tablet') {
    width: 88%;
  }
}
.vuecal__weekdays-headings {
  color: var(--userProfile-textColor) !important;
  // background: var(--userProfile-middleBgColor) !important;
}
.weekday-label {
  color: var(--userProfile-textColor) !important;
  // background: var(--userProfile-middleBgColor) !important;
}
.vuecal__time-column {
  color: var(--userProfile-textColor) !important;
  // background: var(--userProfile-middleBgColor) !important;
}
.vuecal__bg {
  &::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--userProfile-middleBgColor) !important;
    // border-radius: 12px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc !important;
    border-radius: 4px;
    background-image: none !important;
  }
}

.vuecal__title-bar button {
  color: var(--userProfile-textColor) !important;
}
.vuecal__title-bar,
.vuecal__title {
  background-color: transparent !important;
}
// .vuecal__weekdays-headings {
//   // background-color: var(--userProfile-middleBgColor) !important;
// }
.vuecal__event--dragging {
  background-color: #40404040;
}

.vuecal__cell-events {
}

.vuecal__cell-date {
  // color: gray;
  margin: 10px 0;
}
.vuecal__cell--today,
.vuecal__cell--current {
  background-color: #80808040;
}
.vuecal__now-line {
  border: 2px solid var(--userProfile-buttonBgColor);
  color: var(--userProfile-buttonBgColor);
}
.vuecal:not(.vuecal--day-view) .vuecal__cell--selected {
  background-color: #40404080;
}
.vuecal__cell--selected:before {
  border-color: #40404080;
}

.vuecal__event-title {
  margin: 4px 0;
  text-align: left;
}
.vuecal__event-content {
  text-align: left;
}
/* Different color for different event types. */
.default {
  background-color: #aaa;
  color: #fff !important;
}
.typeA {
  background-color: #666666 !important;
  color: #fff !important;
}
.typeB {
  background-color: #42b983 !important;
  color: #fff !important;
}
.typeC {
  background-color: rgba(255, 102, 102, 1) !important;
  color: #fff !important;
}

.vuecal__event {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 10px;
  border-radius: 6px;
}
.vuecal__cell-content {
  background: var(--userProfile-middleBgColor);
  border: none;
  outline: none !important;
}
.day-view {
  .vuecal__cell-content {
    padding: 0 12px;
    width: 96%;
  }
  .vuecal__event {
    right: 0;
  }
}
.month-view {
  .vuecal__cell-content {
    justify-content: flex-start;
    padding: 6px;
    // height: 120px;
  }
  .vuecal__event {
    margin: 4px 0;
    padding: 2px;
    font-size: 0.8rem;
  }
}
.vuecal__time-cell {
  background: var(--userProfile-middleBgColor);
}
/* Cells and buttons get highlighted when an event is dragged over it. */
.vuecal__cell--highlighted:not(.vuecal__cell--has-splits),
.vuecal__cell-split--highlighted {
  background-color: rgba(195, 255, 225, 0.5);
}
.vuecal__arrow.vuecal__arrow--highlighted,
.vuecal__view-btn.vuecal__view-btn--highlighted {
  background-color: rgba(136, 236, 191, 0.25);
}
</style>
